import { ReactNode } from 'react';

import { DropdownMenuSeparator, DropdownMenuTitle } from 'components/Blocks';
import { ProjectOption } from './createProjectOption';

import { ProjectOptionItem } from './Option';
import { useProjectOption } from './options';

interface Props {
  options: ProjectOption[];
  title?: ReactNode;

  addDivisor?: boolean;

  alwaysOn?: ProjectOption[];
}

export function ProjectOptionGroup({ options, alwaysOn = [], ...props }: Props) {
  const [option, ...otherOptions] = options;

  const currentConfig = useProjectOption(option);

  const alwaysOnUpdated =
    currentConfig.isEnabled && !currentConfig.hidden ? [...alwaysOn, option] : alwaysOn;

  if (otherOptions.length)
    return <ProjectOptionGroup options={otherOptions} {...props} alwaysOn={alwaysOnUpdated} />;

  if (!alwaysOnUpdated.length) return null;

  const { addDivisor, title } = props;

  return (
    <>
      {addDivisor && <DropdownMenuSeparator />}

      {title && <DropdownMenuTitle>{title}</DropdownMenuTitle>}

      {alwaysOnUpdated.map((option) => (
        <ProjectOptionItem key={option} option={option} />
      ))}
    </>
  );
}
